import { applyToAllStates } from '../../../theme/utils/button.theme.utils';
export var iconButtonTheme = {
  baseStyle: _ref => {
    var {
      badge
    } = _ref;
    return {
      container: {
        position: badge ? 'relative' : 'unset',
        transitionProperty: 'common',
        transitionDuration: 'normal',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        outline: '2px solid transparent',
        _disabled: {
          cursor: 'not-allowed'
        }
      },
      hitAreaContainer: {
        display: 'inline-flex'
      },
      badge: {
        display: 'inline-flex',
        borderRadius: 'full',
        border: '2px solid #fff',
        position: 'absolute',
        bottom: '-2px',
        right: '-2px',
        backgroundColor: 'neutral.white',
        zIndex: 1
      }
    };
  },
  variants: {
    primary: {
      container: {
        borderRadius: 'l',
        height: '40px',
        width: '40px',
        padding: 'xs',
        border: 'basic.light',
        backgroundColor: 'transparent',
        color: 'neutral.black',
        _hover: {
          backgroundColor: 'neutral.lighter'
        },
        _active: {
          backgroundColor: 'neutral.dark'
        },
        _disabled: applyToAllStates({
          backgroundColor: 'transparent',
          color: 'neutral.light'
        }),
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: '2px',
          transition: 'outline-color 0.2s'
        }
      }
    },
    naked: {
      container: {
        color: 'neutral.darker',
        borderRadius: 'm',
        _hover: {
          color: 'neutral.darkest'
        },
        _active: {
          color: 'neutral.black'
        },
        _disabled: applyToAllStates({
          color: 'neutral.light'
        }),
        _focusVisible: {
          outlineColor: 'focus.focus',
          transition: 'outline-color 0.2s'
        }
      }
    },
    primaryInverted: {
      container: {
        borderRadius: 'l',
        height: '40px',
        width: '40px',
        padding: 'xs',
        border: 'basic.white',
        backgroundColor: 'transparent',
        color: 'neutral.white',
        _hover: {
          backgroundColor: 'rgba(255, 255, 255, 0.15)'
        },
        _active: {
          backgroundColor: 'rgba(255, 255, 255, 0.35)'
        },
        _disabled: applyToAllStates({
          backgroundColor: 'transparent',
          color: 'neutral.white',
          opacity: 0.35
        }),
        _focusVisible: {
          outlineColor: 'focus.invert',
          outlineOffset: '2px',
          transition: 'outline-color 0.2s'
        }
      }
    },
    nakedInverted: {
      container: {
        color: 'neutral.white',
        borderRadius: 'm',
        _hover: {
          opacity: 0.8
        },
        _active: {
          opacity: 0.6
        },
        _disabled: applyToAllStates({
          opacity: 0.35
        }),
        _focusVisible: {
          outlineColor: 'focus.invert',
          transition: 'outline-color 0.2s'
        }
      }
    }
  },
  sizes: {
    large: {
      container: {
        width: '24px',
        height: '24px'
      }
    },
    small: {
      container: {
        width: '16px',
        height: '16px'
      },
      hitAreaContainer: {
        // Increase hit area to 24px to comply to a11y
        // Based on https://stackoverflow.com/a/20327676/23707657
        padding: 'xxs',
        margin: '-4px'
      }
    }
  },
  defaultProps: {
    variant: 'primary',
    size: 'large'
  }
};
//# sourceMappingURL=IconButton.theme.js.map